import { Link } from "react-router-dom";

const NotFound = () => (
  <main className="flex min-h-[65vh] items-center bg-slate-50 px-6 py-16 text-containx-navy">
    <div className="mx-auto max-w-2xl text-center">
      <p className="text-sm font-bold uppercase tracking-widest text-containx-tan">Error 404</p>
      <h1 className="mt-3 text-4xl font-bold md:text-5xl">We couldn’t find that page.</h1>
      <p className="mx-auto mt-5 max-w-xl text-lg leading-8 text-slate-600">The link may be outdated or the page may have moved. Browse our products or contact us and we’ll help you find what you need.</p>
      <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row"><Link to="/products" className="rounded-lg bg-containx-navy px-6 py-3 font-bold text-white hover:bg-containx-charcoal">Browse Products</Link><Link to="/contact" className="rounded-lg border-2 border-containx-navy px-6 py-3 font-bold hover:bg-white">Contact Us</Link></div>
    </div>
  </main>
);

export default NotFound;
